import { useRef, useCallback } from "react";
function useDebouncedCallback(callback, delay) {
  const timeoutRef = useRef();
  return useCallback(
    (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );
}
export {
  useDebouncedCallback
};
//# sourceMappingURL=use-debounced-callback.js.map
